import React, { ReactNode } from 'react';
import { styles } from './CarouselPresentationContainer.css';
import { ContentfulImage } from '../ContentfulImage/ContentfulImage';
import { breakpointSizePx } from '@jbhi-fi/lanyard-ui/themes';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type CarouselPresentationContainerProps = {
  children: Array<ReactNode> | ReactNode;
  coverImageSrc?: string;
  coverImageAlt?: string;
  coverContent?: ReactNode;
  calloutBtn?: ReactNode;
  carouselType?: 'default' | 'video';
};

export const CarouselPresentationContainer = ({
  children,
  coverImageAlt,
  coverImageSrc,
  coverContent,
  calloutBtn,
  carouselType = 'default',
}: CarouselPresentationContainerProps) => {
  return (
    <div className={styles.container({ carouselType })}>
      <div className={styles.contentContainer({ carouselType })}>
        <div className={classNames([styles.cover, styles.coverVariants({ carouselType })])}>
          {coverImageSrc ? (
            <ContentfulImage
              src={coverImageSrc}
              alt={coverImageAlt}
              aspectRatio={425 / 350}
              sizes={`(max-width: ${breakpointSizePx.md}) 100vw, 365px`}
            />
          ) : null}
        </div>

        <div className={styles.content({ carouselType })}>
          {coverContent}
          {calloutBtn ? <div className={styles.calloutBtnDesktop}>{calloutBtn}</div> : undefined}
        </div>
      </div>
      <div className={styles.carouselContainer({ carouselType })}>{children}</div>
      {calloutBtn ? <div className={styles.calloutBtn}>{calloutBtn}</div> : undefined}
    </div>
  );
};
